/* Codex was here 2026-10-22 */
(function () {
  if (!window.imageFunctions) return;

  window.imageFunctions.flickityIosFix = function () {
    var touchingCarousel = false;
    var touchStartCoords;

    document.body.addEventListener('touchstart', function (event) {
      touchingCarousel = Boolean(event.target.closest('.flickity-slider'));

      if (!touchingCarousel || !event.touches.length) return;

      touchStartCoords = {
        x: event.touches[0].pageX,
        y: event.touches[0].pageY
      };
    });

    document.body.addEventListener('touchmove', function (event) {
      if (!(touchingCarousel && touchStartCoords && event.cancelable && event.touches.length)) return;

      var moveVector = {
        x: event.touches[0].pageX - touchStartCoords.x,
        y: event.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7 && Math.abs(moveVector.x) > Math.abs(moveVector.y)) {
        event.preventDefault();
      }
    }, { passive: false });
  };
}());
/* Codex out */
